// VideoPlayer.jsx
import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause, faVolumeMute, faVolumeUp, faExpand } from '@fortawesome/free-solid-svg-icons';

export default function VideoPlayer({ videoUrl }) {

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(videoRef.current.muted);
  };

  const enterFullscreen = () => {
    if (!videoRef.current) return;
    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen();
    } else if (videoRef.current.webkitEnterFullscreen) {
      videoRef.current.webkitEnterFullscreen(); // Safari iOS
    }
  };

  // 👇 Optional: reload the video element when the URL changes
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.load();
      setIsPlaying(true);
    }
  }, [videoUrl]);

  return videoUrl ? (
    <>
      <video
        key={videoUrl}
        ref={videoRef}
        width="100%"
        height="auto"
        controls
        preload="metadata"
        autoPlay
        muted={isMuted}
        loop
        playsInline
        webkit-playsinline="true"
        style={{
          backgroundColor: 'black',
          maxHeight: window.innerWidth > 1024 ? '70vh' : 'none',
          objectFit: 'contain'
        }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div
        className="custom-video-controls"
        style={{
          marginTop: '10px',
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
        }}
      >
        <button onClick={togglePlay} className="button-white button-smaller">
          <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} size="2x" />
        </button>
        <button onClick={toggleMute} className="button-white button-smaller">
          <FontAwesomeIcon icon={isMuted ? faVolumeMute : faVolumeUp} size="2x" />
        </button>
        <button onClick={enterFullscreen} className="button-white button-smaller">
          <FontAwesomeIcon icon={faExpand} size="2x" />
        </button>
      </div>
    </>
  ) : null;

}
